import { render, staticRenderFns } from "./nut-reward-pool.vue?vue&type=template&id=09bf5d85&scoped=true&"
import script from "./nut-reward-pool.vue?vue&type=script&lang=js&"
export * from "./nut-reward-pool.vue?vue&type=script&lang=js&"
import style0 from "./nut-reward-pool.vue?vue&type=style&index=0&id=09bf5d85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf5d85",
  null
  
)

export default component.exports